module.exports = __webpack_public_path__ + "static/media/5-7.8f716c87.jpg";